/**
 * Weld travel speed conversion
 *
 * Notice that this is different from the wire feed speed conversion.
 *
 * See section 3.4.6.1
 * "The travel speed during welding in cm/sec. If provided, this value is used for calculating length-based heat input. Weld travel speed is to be set
using an integer that considers a scaling factor of 0.1. For example, a setting of 12 = 1.2 cm/sec."
 */
export const convertWeldTravelSpeed = {
  /**
   * Convert weld travel speed to weld machine format.
   * @param mps In meters per second
   * @returns In millimeters per second
   */
  toWeldMachine: (mps: number) => Math.round((mps / 100) * 10),

  /**
   * Convert weld travel speed from weld machine format.
   * @param received In millimeters per second
   * @returns In meters per second
   */
  fromWeldMachine: (received: number) => (received * 100) / 10,
};
